// import $ from 'jquery';

export const mainNavToggle = function () {
	// $('.gl-Header_MenuIcon, .js-Nav_Trigger').on('click', function(){
	//     $('.gl-Nav').toggleClass('slideRight');
	//     $('.gl-Nav_PageOverlay').toggleClass('slideRight');
 //        $(document.documentElement).addClass('u-ScrollLock');

	// });
	// $('.gl-Nav_CloseButton').on('click', function(){
	//  	$('.gl-Nav').removeClass('slideRight');
	//  	$('.gl-Nav_PageOverlay').removeClass('slideRight');
 //        $(document.documentElement).removeClass('u-ScrollLock');

	// });
	// $('.gl-Nav_PageOverlay').on('click', function() {
	//  	$('.gl-Nav').removeClass('slideRight');
	//  	$('.gl-Nav_PageOverlay').removeClass('slideRight');
 //        $(document.documentElement).removeClass('u-ScrollLock');
	// });
}
